import { DataHeader } from "..";
import { DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";

export type CloseEventTarget = DataHeader;

export interface CloseListener extends EventListener<CloseEvent> {
}

export abstract class CloseEvent extends Event<CloseEventTarget> {
    private _isBefore: boolean;
    
    constructor(component: CloseEventTarget, isBefore: boolean, domEvent?: DomEvent) {
        super(component, domEvent);
        this._isBefore = isBefore;
    }

    public isBefore() {
        return this._isBefore;
    }

    public isAfter() {
        return !this.isBefore();
    }
}
